import lodashSet from 'lodash.set';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/redux/store';
import { questionnairesApi } from 'app/services/questionnaires';

export type TPleaseProvideDetailsAboutAllUsOwnersincludingYourslfOfTheTrustInTheTableBelow =
  TPleaseProvideDetailsAboutAllUsOwnersincludingYourslfOfTheTrustRow[];

export type TPleaseProvideDetailsAboutAllUsOwnersincludingYourslfOfTheTrustRow =
  {
    name: Nullable<string>;
    ssn: Nullable<string>;
    address: Nullable<string>;
  };

export interface NonUsTrustStateValues {
  nameOfTrust: Nullable<string>;
  streetAddress: Nullable<string>;
  city: Nullable<string>;
  stateOrProvince: Nullable<string>;
  postCode: Nullable<string>;
  country: Nullable<string>;
  dateOfCreation: Nullable<string>;
  endOfTaxYear: Nullable<string>;
  countryOfIncorporation: Nullable<string>;
  pleaseUploadTrustInstrument: Nullable<string>;
  pleaseUploadTrustBalanceSheet: Nullable<string>;
  pleaseUploadTrustIncomeStatement: Nullable<string>;
  haveYouFiledForm3520A: Nullable<TYesOrNo>;
  whenDidYouLastFile3520A: Nullable<string>;
  whichYear: Nullable<string>;
  didYouTransferAssetsOrCashToTheTrustInYear: Nullable<TYesOrNo>;
  howMuchDidYouTransfer: Nullable<string>;
  currency: Nullable<string>;
  pleaseProvideDetails: Nullable<string>;
  areThereOtherUsOwnersForTheTrust: Nullable<TYesOrNo>;
  pleaseProvideDetailsAboutAllUsOwnersincludingYourslfOfTheTrustInTheTableBelow: TPleaseProvideDetailsAboutAllUsOwnersincludingYourslfOfTheTrustInTheTableBelow;
  didYouReceivedACashOrPropertyDistributionFromTheTrust: Nullable<TYesOrNo>;
  pleaseUploadDocumentReportingTheDistribution: Nullable<string>;
  endOf2StForeignTrustRecord: Nullable<string>;
}

export interface NonUsTrustState {
  values: NonUsTrustStateValues;
}

const initialState: NonUsTrustState = {
  values: {
    nameOfTrust: null,
    streetAddress: null,
    city: null,
    stateOrProvince: null,
    postCode: null,
    country: null,
    dateOfCreation: null,
    endOfTaxYear: null,
    countryOfIncorporation: null,
    pleaseUploadTrustInstrument: null,
    pleaseUploadTrustBalanceSheet: null,
    pleaseUploadTrustIncomeStatement: null,
    haveYouFiledForm3520A: null,
    whenDidYouLastFile3520A: null,
    whichYear: null,
    didYouTransferAssetsOrCashToTheTrustInYear: null,
    howMuchDidYouTransfer: null,
    currency: null,
    pleaseProvideDetails: null,
    areThereOtherUsOwnersForTheTrust: null,
    pleaseProvideDetailsAboutAllUsOwnersincludingYourslfOfTheTrustInTheTableBelow:
      [{ name: null, ssn: null, address: null }],
    didYouReceivedACashOrPropertyDistributionFromTheTrust: null,
    pleaseUploadDocumentReportingTheDistribution: null,
    endOf2StForeignTrustRecord: null,
  },
};

const nonUsTrustSlice = createSlice({
  name: 'nonUsTrust',
  initialState,
  reducers: {
    update(state, action: PayloadAction<NonUsTrustStateValues>) {
      state.values = JSON.parse(JSON.stringify(action.payload));
    },
    updateKey(
      state,
      action: PayloadAction<{
        key:
          | keyof NonUsTrustStateValues
          | keyof TPleaseProvideDetailsAboutAllUsOwnersincludingYourslfOfTheTrustRow;
        value: any;
      }>,
    ) {
      lodashSet(state, `values.${action.payload.key}`, action.payload.value);
    },
    updateFieldArrayKey(
      state,
      action: PayloadAction<{
        key:
          | keyof NonUsTrustStateValues
          | keyof TPleaseProvideDetailsAboutAllUsOwnersincludingYourslfOfTheTrustRow;
        value: TPleaseProvideDetailsAboutAllUsOwnersincludingYourslfOfTheTrustInTheTableBelow;
      }>,
    ) {
      const fieldArray = action.payload.value.map((field) => ({ ...field }));
      if (
        action.payload.key ===
        'pleaseProvideDetailsAboutAllUsOwnersincludingYourslfOfTheTrustInTheTableBelow'
      ) {
        state.values[action.payload.key] = fieldArray;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      questionnairesApi.endpoints.getQuestionnaireById.matchFulfilled,
      (state, { payload }) => {
        state.values = payload.questionnaire.data.taxQuestionnaire
          ? payload.questionnaire.data.taxQuestionnaire.income.corporationTrust
              .nonUsTrust.values
          : initialState.values;
      },
    );
  },
});

export const { update, updateKey, updateFieldArrayKey } =
  nonUsTrustSlice.actions;
export default nonUsTrustSlice.reducer;

export const selectNonUsTrust = (state: RootState) =>
  state.taxQuestionnaire.income.corporationTrust.nonUsTrust;
